/// ProjectPanel: Left sidebar panel showing open diagrams and deployed processes.
/// Two sections: "Diagrams" (open editor tabs from editorStore) and
/// "Deployed" (processes/flows deployed to engine workers from engineStore).

import { RefreshCw } from "lucide-react";
import { useEditorStore } from "@/stores/editorStore";
import { useEngineStore } from "@/stores/engineStore";
import { DiagramList } from "./project/DiagramList";
import { ProcessList } from "./project/ProcessList";

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function ProjectPanel() {
  const tabCount = useEditorStore((s) => s.tabs.length);
  const processCount = useEngineStore((s) => s.deployedProcesses.length);
  const flowCount = useEngineStore((s) => s.deployedNodeFlows.length);
  const deployedCount = processCount + flowCount;

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-zinc-700 px-3 py-2">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-zinc-400 uppercase tracking-wider">
            Project
          </span>
          {(tabCount > 0 || deployedCount > 0) && (
            <span className="text-xs text-zinc-500 tabular-nums">
              {tabCount} open
              {deployedCount > 0 && ` / ${deployedCount} deployed`}
            </span>
          )}
        </div>
        <button
          className="rounded p-1 text-zinc-500 hover:text-zinc-300 hover:bg-zinc-800 transition-colors"
          title="Refresh"
          onClick={() => {
            // Trigger a re-render by touching the store
            // In the future this could re-fetch from engine workers
          }}
        >
          <RefreshCw size={12} />
        </button>
      </div>

      {/* Scrollable content */}
      <div className="flex-1 overflow-y-auto py-1">
        {/* Open diagrams section */}
        <DiagramList />

        {/* Deployed processes section (collapsible divider) */}
        {deployedCount > 0 && (
          <div className="mt-3 border-t border-zinc-700 pt-1">
            <ProcessList />
          </div>
        )}
      </div>
    </div>
  );
}
